// extracted by mini-css-extract-plugin
export default {"SubmitButton":"SubmitButton_SubmitButton__8k8qc","LoadingIndicator":"SubmitButton_LoadingIndicator__UZLSv"};